// Import Dependencies
import React, { Component, Fragment } from 'react';

import CommonButton from '~/common/components/CommonButton';

// Import Local Styles
import styles from './account-modal.css';

export default class AccountModal extends Component {
    componentDidMount() {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    }

    render() {
        return (
            <Fragment>
                <div className={styles.grid}>
                    <h1 className={styles.header}>Welcome Back!</h1>
                    <span className={styles.subheader}>Your email is already in the system. Please log in to continue.</span>
                    <CommonButton>
                        Log In
                    </CommonButton>
                    <span>
                        If you need help, please call Customer Service at (877) 582-7011 (Toll-free) or 1 805 617 7370 (Long Distance).
                    </span>
                </div>
            </Fragment>
        );
    }
}
